module.exports = __webpack_public_path__ + "files/a553c8a5d11d03fa980a227571fad504.png";